export const HOME = '/';
export const NOT_FOUND = '/404';
export const HELP = '/help';
export const ERROR = '/error';
export const EARLY = '/early-childhood';
export const ELEMENTARY = '/elementary';
export const PRETEEN = '/preteen';